export default "__VITE_ASSET__BjtrRT0Z__"